@if (config.currentUser) {
  <div class="manage-profile-row" (click)="changeProfileEvent(config.currentUser);">
    <div class="manage-profile-img">
      <img src="./assets/images/profile-user-new.svg" class="rounded-circle">
    </div>
    <div class="manage-profile-name" [ngClass]="autheticationService.getCurrentUser().user_id == config.currentUser.user_id ? 'active':''">
      <div class="">{{config.currentUser.first_name}}</div>
    </div>
    <div class="manage-profile-type">
      <div class="manage-profile-default-icon">
        <i class="fa fa-star"></i>
      </div>
      <div class="_card-sub-heading">{{'Default' | translate | async}}</div>
    </div>
  </div>
}
@if (config.data) {
  @for (data of config.data; track data) {
    <div class="manage-profile-row" (click)="changeProfileEvent(data);">
      <div class="manage-profile-img" >
        <img src="./assets/images/profile-user-new.svg" class="rounded-circle">
      </div>
      <div class="manage-profile-name" [ngClass]="autheticationService.getCurrentUser().user_id == data.mapped_id ? 'active':''">
        <div class="select-profile">{{data.mapped_name}}</div>
        <!-- <div class="_card-sub-heading" style="font-weight: 100;">9643583931</div> -->
      </div>
    </div>
  }
}

@if (config.currentUser && config.currentUser.user_id == config.currentId) {
  <div class="manage-profile-row add-family-row">
    <div class="manage-profile-add-more-icon">
      <i class="fa fa-user-circle-o"></i>
      <!-- <i class="fa fa-user-plus" aria-hidden="true"></i> -->
    </div>
    <div class="manage-profile-name">
      <div class="manage-profile-add-more" (click)="addMember();">{{'Add Family Member' | translate | async}}</div>
    </div>
  </div>
}